module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": "graph-user-growth",
      "height": "70"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-63fc1b2f"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/UserGrowthGraph.vue
// module id = 1024
// module chunks = 0